export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/918861133745?text=Hi%2C%20I%27m%20interested%20in%20Confident%20Auriga.%20Please%20share%20more%20details."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-5 z-40 w-12 h-12 md:w-16 md:h-16 md:bottom-6 md:right-6 bg-green-600 hover:bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 group"
      aria-label="WhatsApp Enquiry"
    >
      <i className="ri-whatsapp-line text-white text-xl md:text-3xl"></i>
      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-charcoal text-white text-xs font-body rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden md:block">
        Chat on WhatsApp
      </span>
    </a>
  );
}